import axiosInstance from "../Axios";

function getMinimumWagesList(pageNo = 1, params) {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }

    return axiosInstance.get("/minimum-wages", { params: queryParams });
  } catch (error) {
    console.log("Error while fetching Minimum Wages list:", error);
    throw error;
  }
}

function createMinimumWages(data) {
  try {
    return axiosInstance.post("/minimum-wages", data);
  } catch (error) {
    console.log("Error while creating Minimum Wages:", error);
    throw error;
  }
}

function updateMinimumWages(id, data) {
  try {
    return axiosInstance.put(`/minimum-wages/${id}`, data);
  } catch (error) {
    console.log("Error while updating Minimum Wages:", error);
    throw error;
  }
}

function deleteMinimumWages(id) {
  try {
    return axiosInstance.delete(`/minimum-wages/${id}`);
  } catch (error) {
    console.log("Error while deleting Minimum Wages:", error);
    throw error;
  }
}

// --- Zone API Calls ---
function getZones() {
  try {
    return axiosInstance.get("/compliance/states");
  } catch (error) {
    console.log("Error while fetching state:", error);
    throw error;
  }
}

export {
  getMinimumWagesList,
  createMinimumWages,
  updateMinimumWages,
  deleteMinimumWages,
  getZones,
};
